import { render, staticRenderFns } from "./WithBg.vue?vue&type=template&id=469d09e2&scoped=true&"
import script from "./WithBg.vue?vue&type=script&lang=js&"
export * from "./WithBg.vue?vue&type=script&lang=js&"
import style0 from "./WithBg.vue?vue&type=style&index=0&id=469d09e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d09e2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default,AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
